import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import ProposalPipeline from './Index.vue';
import ProposalDetail from './ProposalDetail.vue';

export const routes = [
  {
    path: 'propostas',
    name: 'talkvia_proposals',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    featureFlag: FEATURE_FLAGS.TALKVIA_CORBAN_PROPOSAL_PIPELINE,
    component: ProposalPipeline,
  },
  {
    path: 'propostas/:id',
    name: 'talkvia_proposal_detail',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    featureFlag: FEATURE_FLAGS.TALKVIA_CORBAN_PROPOSAL_PIPELINE,
    component: ProposalDetail,
  },
];
